import * as React from 'react';
import { CircularProgressBase } from 'react-native-circular-progress-indicator';
import { CheckIcon, Icon, useThemeColors, View } from 'smoothie';

import { GoalCardContext, GoalStatus } from '../../types/Goal';

interface GoalProgressProps {
    totalTaskCount: number;
    completedTaskCount: number;
    status: GoalStatus;
    context: GoalCardContext;
}

const GoalProgress = ({
    totalTaskCount,
    completedTaskCount,
    status,
    context,
}: GoalProgressProps) => {
    const { getColor } = useThemeColors();
    const allTasksCompleted = totalTaskCount === completedTaskCount;
    const isGoalComplete = status === GoalStatus.COMPLETE;

    return (
        <CircularProgressBase
            radius={15}
            value={(completedTaskCount / totalTaskCount) * 100}
            inActiveStrokeWidth={5}
            inActiveStrokeColor={getColor('$gray100')}
            activeStrokeWidth={3}
            activeStrokeColor={getColor('$green1000')}
        >
            {allTasksCompleted &&
                !isGoalComplete &&
                context !== GoalCardContext.COMPLETED_SHEET && (
                    <View
                        backgroundColor="$green200"
                        width={20}
                        height={20}
                        borderRadius={10}
                    ></View>
                )}
            {(isGoalComplete ||
                context === GoalCardContext.COMPLETED_SHEET) && (
                <Icon icon={CheckIcon} size={12} color="$green1000" />
            )}
        </CircularProgressBase>
    );
};

export default GoalProgress;
